import { ICategoryVote } from 'api/types/_campaign';
import { Option } from 'api/types/_public';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import DropdownCategoryVote from 'components/Common/DropdownCategoryVote';
import Hashtag from 'components/Common/Hashtag';
import LabelWrapper from 'components/Common/LabelWrapper';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { formatNumberWithCommas } from 'helpers/format';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Badge, CardBody, CardHeader, Col, Input, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import TableContainer from "../../../components/Common/TableContainer";
import { allCategoryVote, getAllTagKeywordVote, getKeywordVotes as onGetKeywordVotes, putTagKeywordVote } from "../../../store/thunks";
import { Link } from 'react-router-dom';
import TooltipCustom from 'components/Common/TooltipCustom';
import KeywordForm from './KeywordForm';
import InputsRange from 'components/Common/InputsRange';
import DropdownMultiOption from 'components/Common/DropdownMultiOption';
import ModalMultiPreview from 'components/Common/ModalMultiPreview';
export interface Tag {
    id: string;
    text: string;
}

const TYPE_SELECT_DEFAULT: string = 'daily_search_volume';

registerLocale('en', en);
registerLocale('ko', ko);

const KeywordList = (activeTab?: any) => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 30),
        sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        order_by: withDefault(StringParam, 'DESC'),
        is_active: withDefault(StringParam, ''),
        keyword: withDefault(StringParam, ''),
        category_id: withDefault(StringParam, ''),
        daily_search_volume_start: withDefault(StringParam, ''),
        daily_search_volume_end: withDefault(StringParam, ''),
        tag_ids: withDefault(StringParam, ''),
    });

    const [categoryVote, setCategoryVote] = useState<ICategoryVote[]>([]);

    const [keywordSearch, setKeywordSearch] = useState<string>(query?.keyword || "");

    const [categorySearch, setCategorySearch] = useState<Option | null>(null);

    const [startDailyVolumeSearch, setStartDailyVolumeSearch] = useState<string>(query?.daily_search_volume_start || "");
    const [endDailyVolumeSearch, setEndDailyVolumeSearch] = useState<string>(query?.daily_search_volume_end || "");

    const [tagsSearch, setTagsSearch] = useState<Option[] | null>(null);

    const [tags, setTags] = useState<Option[]>([]);

    const [previewImages, setPreviewImages] = useState<{ urls: { url: string, type: 'image' }[] } | null>(null);

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.Campaign;

    const CampaignProperties = createSelector(
        selectLayoutState,
        (state) => ({
            keywordVotes: state.keywordVotes,
            isKeywordVoteSuccess: state.isKeywordVoteSuccess,
            isKeywordVoteLoading: state.isKeywordVoteLoading,
            error: state.error,
        })
    );

    // Inside your component
    const { keywordVotes, error, isKeywordVoteLoading } = useSelector(CampaignProperties);

    useEffect(() => {
        dispatch(onGetKeywordVotes(query));
    }, [JSON.stringify(query)]);

    const searchData = () => {
        const queryNew = {
            ...query,
            keyword: keywordSearch || '',
            category_id: categorySearch?.value || '',
            daily_search_volume_start: startDailyVolumeSearch || '',
            daily_search_volume_end: endDailyVolumeSearch || '',
            tag_ids: (tagsSearch || [])?.map((_t: any) => _t?.value)?.join(',') || '',
            page: 1,
            time_request: + new Date()
        };
        setQuery(queryNew);
    };

    const resetData = () => {
        const queryNew = {
            ...query,
            keyword: '',
            category_id: '',
            daily_search_volume_start: '',
            daily_search_volume_end: '',
            tag_ids: '',
            order_by: 'DESC',
            sort_by: TYPE_SELECT_DEFAULT,
            time_request: + new Date(),
            page: 1,
        };
        setQuery(queryNew, "push");
        setKeywordSearch('');
        setCategorySearch((_prev) => null);
        setStartDailyVolumeSearch(queryNew?.daily_search_volume_start);
        setEndDailyVolumeSearch(queryNew?.daily_search_volume_end);
        setTagsSearch(null);
    };

    const triggerRefresh = async () => {
        onCloseClick();
        onCloseKeywordDetailClick();
        handleReloadTag();
        dispatch(onGetKeywordVotes(query));
    }
    //End::Update

    const onCloseClick = () => {
        setItemUpdateTags(null);
    }

    // Begin:: update tags news
    const [itemUpdateTags, setItemUpdateTags] = useState<{ id: number, tags: { id: string, text: string }[] } | null>(null);
    const [isLoadingUpdateTags, setIsLoadingUpdateTags] = useState<boolean>(false);

    const handleUpdateTags = async () => {
        try {
            if (!itemUpdateTags) {
                return;
            }
            setIsLoadingUpdateTags((_prev) => true);
            const _tags: string[] = (itemUpdateTags?.tags || [])?.map((_tag: any) => `${_tag?.text || ''}`);
            const response: any = await putTagKeywordVote(itemUpdateTags?.id, { tags: _tags });
            setIsLoadingUpdateTags((_prev) => false);
            if (response?.code === 200) {
                setQuery((_prev: any) => ({ ..._prev, time_request: + new Date() }));
                setItemUpdateTags((_prev) => null);
                triggerRefresh();
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
            } else {
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsLoadingUpdateTags((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    }
    // End:: update tags news

    const [keywordDetail, setKeywordDetail] = useState<any>(null);

    const handleSetKeywordDetail = (_item: any) => {
        setKeywordDetail(() => _item);
    };

    const onCloseKeywordDetailClick = () => {
        setKeywordDetail(null);
    }

    // Column
    const columns = useMemo(
        () => [
            {
                Header: t('ID'),
                accessor: "keyword_id",
                filterable: true,
                sortable: true,
                thWidth: 90,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => (
                    <>
                        <div style={{ minWidth: '70px' }}>{cell?.value}</div>
                    </>
                ),
            },
            {
                Header: t('Image'),
                accessor: "images",
                thClass: 'text-center',
                filterable: true,
                sortable: false,
                thWidth: 130,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _preview = {
                        urls: (item?.images || [])?.map((_img: any) => ({
                            url: _img?.image_url,
                            type: 'image',
                            description: item?.keyword || ''
                        }))
                    };
                    return (
                        <>
                            <div className="w-100 text-center" style={{ minWidth: '100px' }} onClick={() => setPreviewImages(() => _preview)}>
                                <div style={{ width: '90px', height: '90px' }} className="m-auto cursor-pointer position-relative">
                                    {item?.images?.[0] && <img src={item?.images?.[0]?.thumbnail_url || ''} className="flex-shrink-0 rounded w-100 h-100 object-fit-cover" alt={item?.keyword} />}
                                    <Badge pill color="danger" className="position-absolute top-5 start-0 translate-middle">
                                        {item?.images?.length || 0}
                                    </Badge>
                                </div>
                            </div>
                        </>
                    )
                },
            },
            {
                Header: t('Keyword'),
                accessor: "keyword",
                filterable: true,
                sortable: false,
                thWidth: 160,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '140px' }} className="d-flex flex-wrap ">
                            {item?.keyword || '-'}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Category'),
                accessor: "categories",
                filterable: true,
                sortable: false,
                thWidth: 220,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '190px' }} className="d-flex flex-column flex-wrap ">
                            {(item?.categories || [])?.map((_c: any) => (
                                <div key={_c?.category_id}>{_c?.groups?.[0]?.title ? `${_c?.groups?.[0]?.title || ''} > ` : ''} {_c?.title || '-'} </div>
                            ))}
                            {(item?.categories || [])?.length === 0 && <>-</>}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Daily Search Volume'),
                accessor: "daily_search_volume",
                filterable: true,
                sortable: true,
                thWidth: i18n?.language === 'en' ? 190 : 140,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (!!item?.text_row ? <div className="text-end pe-3 " style={{ minWidth: i18n?.language === 'en' ? '170px' : '120px' }}>
                        -
                    </div> :
                        <div className="text-end pe-3" style={{ minWidth: i18n?.language === 'en' ? '170px' : '120px' }}>{formatNumberWithCommas(cell?.value || 0)}</div>
                    )
                },
            },
            {
                Header: t('Tags'),
                accessor: "tags",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'align-middle text-end pe-3',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _tags = (item?.tags || [])?.map((_tag: any) => ({ id: _tag?.name, text: _tag?.name }));
                    return (!!item?.text_row ? <div className="d-flex justify-content-end align-items-center pe-2">-</div> :
                        <div className="d-flex justify-content-between align-items-center">
                            <div style={{ width: '110px' }} className="d-flex justify-content-end flex-wrap align-items-center gap-1 fs-16">
                                {(item?.text_row || !(item?.tags || [])?.length) ? <>-</> : <>{(item?.tags || [])?.map((_tags: any) => (
                                    <span key={_tags?.id} className="badge bg-primary-subtle text-primary">
                                        {_tags?.name || ''}
                                    </span>
                                ))}</>}
                            </div>
                            <div>
                                {!!cell?.value && <button className="btn btn-sm edit-item-btn text-primary"
                                    onClick={(e) => { e.stopPropagation(); e.preventDefault(); setItemUpdateTags(() => ({ id: item?.keyword_id, tags: _tags })) }}
                                >
                                    <i className="ri-pencil-fill align-bottom"></i>
                                </button>}
                            </div>
                        </div>)
                },
            },
            {
                Header: t('Created At'),
                accessor: "created_at",
                filterable: true,
                sortable: true,
                thWidth: 130,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '120px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Updated at'),
                accessor: "updated_at",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'text-end align-middle',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end" style={{ minWidth: '100px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Actions'),
                accessor: "__",
                thClass: 'align-middle text-center',
                thWidth: 80,
                sortable: false,
                Cell: (cell: any) => {
                    const item: any = cell?.row?.original;
                    return (
                        <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '50px' }}>
                            {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_KEYWORD_UPDATE, userPermissions) && <TooltipCustom
                                title={t('Button Update Keyword')}
                                id={`update-us-${item?.id}`}
                            >
                                <li className=" list-inline-item me-0" id={`update-us-${item?.id}`}>
                                    <Link className="btn btn-sm btn-soft-primary edit-item-btn" to="#"
                                        onClick={(e) => { e.preventDefault(); handleSetKeywordDetail(item) }}
                                    >
                                        <i className="ri-pencil-fill align-bottom"></i>
                                    </Link>
                                </li>
                            </TooltipCustom>}
                        </ul>
                    );
                },
            },
        ],
        [i18n?.language, JSON.stringify(query), JSON.stringify(userPermissions)]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy });
        });
    }, []);


    const handleReloadTag = async () => {
        const [res1]: any = await Promise.all([getAllTagKeywordVote({})]);
        const _tags = (res1?.data)?.map((_t: any) => ({ label: _t?.name, value: `${_t?.id}` }));
        setTags((_prev: any) => _tags);

    };

    const handleCallAllOption = async () => {
        try {
            const [res1, res2]: any = await Promise.all([allCategoryVote(), getAllTagKeywordVote({})]);
            const _list_category_vote = (res1?.data || []);
            const _tags = (res2?.data || [])?.map((_t: any) => ({ label: _t?.name, value: `${_t?.id}` }));
            setCategoryVote((_prev: any) => _list_category_vote);
            setTags((_prev: any) => _tags);

            if (query?.tag_ids) {
                const _tag_ids = _tags?.filter((_p: any) => (String(query?.tag_ids)?.split(','))?.includes(String(_p?.value)));
                setTagsSearch(_tag_ids);
            }
        } catch (error: any) {
            return error;
        }
    };


    useEffect(() => {
        handleCallAllOption();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <Row>
                {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_LIST, userPermissions) && (
                    <Col lg={12}>
                        <div>
                            <CardHeader className="border-0">
                                <Row className="g-4 align-items-center">
                                    <div className="col-sm-7">
                                        <div>
                                            <h5 className="card-title mb-0">
                                                <span>
                                                    <span className="me-2">{t('Total')}:</span>
                                                    {(isKeywordVoteLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={keywordVotes?.pagination?.total || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                    {/* <div className="col-sm-5 text-end">
                                        {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_CREATE, userPermissions) && (<div className="col-sm-auto">
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-success add-btn rounded-pill"
                                                    id="create-btn"
                                                    onClick={() => {
                                                        handleSetCampaignDetail({ time_request: + new Date() } as any)
                                                    }}
                                                >
                                                    <i className="ri-add-line align-bottom me-1"></i>
                                                    {t('Button Create Campaign')}
                                                </button>
                                            </div>
                                        </div>)}
                                    </div> */}
                                </Row>
                            </CardHeader>
                            <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                <Row className="g-4 align-items-center mt-0">
                                    <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-2'>
                                        <LabelWrapper label={t('Keyword')} isShow={!!keywordSearch}>
                                            <Input
                                                type="text"
                                                className="form-control search"
                                                placeholder={`${t('Keyword')}...`}
                                                value={keywordSearch}
                                                onChange={(e) => setKeywordSearch(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        searchData();
                                                    }
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='mt-3 mt-xxl-2'>
                                        <InputsRange
                                            nameFrom="from"
                                            nameTo="to"
                                            valueFrom={startDailyVolumeSearch}
                                            valueTo={endDailyVolumeSearch}
                                            placeholderFrom={`${t('Daily Search Volume (Start)')}...`}
                                            placeholderTo={`${t('Daily Search Volume (End)')}...`}
                                            labelFrom={`${t('Daily Search Volume (Start)')}`}
                                            labelTo={`${t('Daily Search Volume (End)')}`}
                                            isTypeNumber={true}
                                            onChangeFrom={(val) => setStartDailyVolumeSearch(val)}
                                            onChangeTo={(val) => setEndDailyVolumeSearch(val)}
                                            onKeyDownFrom={(e) => {
                                                if (e.key === "Enter") {
                                                    searchData();
                                                }
                                            }}
                                            onKeyDownTo={(e) => {
                                                if (e.key === "Enter") {
                                                    searchData();
                                                }
                                            }}
                                        />
                                    </Col>

                                    <Col sm={6} md={6} lg={6} xl={6} xxl={3} className='mt-3 mt-xxl-2'>
                                        <LabelWrapper label={t('Category')} isShow={true}>
                                            <DropdownCategoryVote
                                                name="category_id"
                                                placeholder={t('Category')}
                                                isClearable={false}
                                                dataList={categoryVote}
                                                initialValue={categorySearch}
                                                onChangeCategory={(event) => {
                                                    setCategorySearch(event);
                                                }}
                                                className="dropdown-status-rounded"
                                                classNamePrefix="name-prefix"
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    <Col sm={6} md={6} lg={6} xl={6} xxl={3} className='mt-3 mt-xxl-2'>
                                        <LabelWrapper label={t('Tags')} isShow={!!tagsSearch?.length}>
                                            <DropdownMultiOption
                                                name="tag_ids"
                                                dataList={tags}
                                                placeholder={`${t("Tags")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={tagsSearch || []}
                                                onChangeSelect={(e: any) => setTagsSearch(e)}
                                                isHasOptionAll={false}
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    {/* <Col sm={6} md={6} lg={6} xl={4} xxl={3} className='mt-3 mt-xxl-2'>
                                        <LabelWrapper label={t('Status')} isShow={true}>
                                            <DropdownStatus
                                                name="status"
                                                dataList={STATUS_CAMPAIGN_OPTIONS_LANG || []}
                                                placeholder={`${t("Status")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={statusSearch || null}
                                                onChangeSelect={(e: any) => setStatusSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                                colors={COLORS_STATUS_CAMPAIGN}
                                            />
                                        </LabelWrapper>
                                    </Col> */}

                                    <Col sm={12} md={12} lg={12} xl={12} xxl={12} className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-xl-end mt-3 mt-xxl-3">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2 "
                                                onClick={searchData}
                                                disabled={isKeywordVoteLoading}
                                            >
                                                <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                {t('Button Search')}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary fs-14"
                                                onClick={resetData}
                                            >
                                                <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                {t('Button Reset')}
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <CardBody className="pt-3">
                                <TableContainer
                                    className="custom-header-css"
                                    divClass="table-responsive table-card "
                                    tableClass="align-middle sticky-table-campaign-gold-price"
                                    theadClass="table-light"
                                    columns={columns}
                                    data={keywordVotes?.list?.length ? keywordVotes?.list : []}
                                    customPageSize={query.limit}
                                    customPageIndex={query.page - 1}
                                    totalRecords={keywordVotes?.pagination?.total}
                                    customPageCount={Math.ceil(Number(keywordVotes?.pagination?.total) / Number(keywordVotes?.pagination?.limit))}
                                    handleChangePage={handleChangePage}
                                    manualSorting={true}
                                    sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                    handleChangeSorting={handleChangeSorting}
                                    isLoading={isKeywordVoteLoading}
                                    isShowHeaderTableFixedTab={activeTab}
                                />
                            </CardBody>
                        </div>
                    </Col>
                )}
            </Row>

            <KeywordForm
                isOpen={!!keywordDetail}
                detail={keywordDetail}
                onClose={onCloseKeywordDetailClick}
                triggerRefresh={triggerRefresh}
            />

            <Modal
                isOpen={!!itemUpdateTags?.id}
                centered={true}
                size="md"
                toggle={() => setItemUpdateTags((_prev) => null)}
                keyboard={true}
            >
                <ModalHeader toggle={() => setItemUpdateTags((_prev) => null)}>
                    {t('Button Update Tags')}
                </ModalHeader>
                <ModalBody className="">
                    <Col md={12} lg={12}>
                        <div>
                            <div style={{ minHeight: '80px' }}>
                                <label className="form-label">
                                    {t("Tags")}
                                </label>
                                <Hashtag
                                    name="tags"
                                    placeholder={`${t("Press Enter to add a new tag")}...`}
                                    suggestions={[]}
                                    initialValue={itemUpdateTags?.tags || []}
                                    onChangeTag={(event: any) => {
                                        setItemUpdateTags((prev: any) => ({ ...prev, tags: event }))
                                    }}
                                    idSelected="hashtags-CampaignFormMulti"
                                    maxHashtags={2000}
                                    maxHeight="150px"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col lg={12}>
                        <div className="hstack gap-2 justify-content-sm-center justify-content-md-end mt-3">
                            <button
                                className="btn btn-soft-secondary rounded-pill fs-14 me-2"
                                color="light"
                                type="button"
                                disabled={isLoadingUpdateTags}
                                style={{ width: '100px' }}
                                onClick={() => setItemUpdateTags((_prev) => null)}
                            >
                                {t("Button Close")}
                            </button>
                            <button
                                className="btn btn-primary rounded-pill fs-14"
                                color="success"
                                type="button"
                                disabled={isLoadingUpdateTags}
                                style={{ width: '150px' }}
                                onClick={() => handleUpdateTags()}
                            >
                                {isLoadingUpdateTags ? (
                                    <Spinner size="sm" className="me-2"></Spinner>
                                ) :
                                    <> {t("Button Update")}</>}
                            </button>
                        </div>
                    </Col>
                </ModalBody>
            </Modal>

            <ModalMultiPreview
                isOpen={!!previewImages}
                urls={previewImages?.urls || []}
                onClose={() => setPreviewImages((_prev: any) => null)}
            />

            <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={3000} limit={2} />
        </React.Fragment >
    );
};

export default KeywordList;